<template>
  <div style="width: 300px">
    <div class="fer">
      <slot name="MingChen"></slot>
    </div>
    <ul>
      <slot name="ContentEr"></slot>

      <slot name="ContentEryi"></slot>

      <slot name="ContentSan"></slot>

      <slot name="ContentSanEr"></slot>

      <slot name="ContentSi"></slot>

      <slot name="ContentWu"></slot>
    </ul>

    <div class="ZhiDian">
      <el-image  style="width: 24px; height: 24px;position: relative; top: 14px;" :src="telephone"></el-image>
          <span class="rexian">{{ $t("menu.ZhiXun") }}</span><br>
        <div class="Title">{{ $t("menu.landlineMachine") }}</div>
    </div>


  </div>
</template>

<style scoped>
.Title{
    font-weight: bold;
    color: #1D2088;
   font-size: 16px;
    padding-left: 33px;
}
.rexian{
     font-size: 16px;
     color: #333333;
         padding-left: 10px;
}
ul {
  padding: 0px;
  margin-top: 0px;
}
ul li {
  width: 280px;
  /* line-height: 64px; */
  height: 64px;
      display: flex;
    align-items: center;
  list-style: none;
  background: #ffffff;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
  padding-left: 20px;
  color: #333333;
  font-size: 16px;
}
ul li:hover,
ul li:focus {
  color: #1d2088;
}
.fer {
  height: 64px;
  width: 280px;
  margin-top: 20px;
  line-height: 64px;
  background: #ffffff;
  font-size: 24px;
  color: #ffffff;
  padding-left: 20px;
  background: #1d2088;
}
.ZhiDian {
  /* height: 64px; */
  width: 280px;
  /* line-height: 64px; */
  background: #ffffff;
  margin: 20px 0px;
  padding: 15px;
  padding-right: 5px;
  color: #333333;
  /* font-size: 24px; */
      /* display: flex;
    justify-content: start;
    align-items: center; */
}
</style>
<script>
export default {
  name: "Content",

  data() {
    return {
      telephone: require("@/assets/images/about/icon_dianhua.png"),
       dialogVisible: false,
    };
  },
  methods: {},
};
</script>